<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{'Facilities'|translate}}
                </v-card-title>
                <v-card-actions>
                    <span style="width:300px;"><v-text-field  class="ml-2" clearable v-model="search" type="text" :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>
                    <v-btn class="accent mr-2" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Facility')"><v-icon small class="mr-2">fa-plus</v-icon> {{'Add Record'|translate}}</v-btn>
                    <facility-record-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></facility-record-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="facility"
                    class="elevation-1"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :items-per-page="25"
                    :search="search2"
            >
      <template v-slot:items="props">
        <td>{{ props.item.facility_id }}</td>
        <td class="text-xs-left">{{ props.item.facility_name}}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left">{{ props.item.meta }}</td>
        <td class="text-xs-left">{{ props.item.sampling_freq }}</td>
        <td class="justify-center">
          <v-icon
            small
            class="mr-2"
            v-if="$can('update', 'Facility')"
            @click="$can('update', 'Facility') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            v-if="$can('update', 'Facility')"
            @click="$can('update', 'Facility') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">{{'Reset'|translate}}</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getFacility, deleteFacility} from '../helper'
import FacilityRecordDialog from '../components/facility/FacilityRecordDialog'

export default {
    name: 'Facility',
  components: { FacilityRecordDialog },
  data(){
    return{
      dialog: false,
      headers: [
        {
          text: this.$options.filters.translate('Facility ID'),
          align: 'left',
          sortable: true,
          value: 'facility_id'
        },
        { text: this.$options.filters.translate('Facility Name'), value: 'facility_name'},
        { text: this.$options.filters.translate('Description'), value: 'description' },
        { text: this.$options.filters.translate('Meta'), value: 'meta', sortable: false },
        { text: this.$options.filters.translate('Sampling Frequency'), value: 'sampling_freq', sortable: false},
        { text: this.$options.filters.translate('Actions'), sortable: false },
      ],
      facility: [
        {
          'facility_id': 1,
          'facility_name': 'Facility Name',
          'description': 'Description',
          'meta': 'Meta',
          'sampling_freq': 1
        },
      ],
      editedItem: {
      },
      search: '',
      search2: ''
    }},
    watch: {
      search(){
        this.debounce(this.syncSearches,500);
      }
    },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?')) ){
          await deleteFacility({
            'facility_id': item.facility_id
          })
          this.refresh()
        }
      },
      async refresh() {
        let df = await getFacility({
        })
        this.facility = df['result']
      },
      syncSearches(){
        this.search2=this.search
      },
      debounce(callback, wait) {
        clearTimeout(this.timeout);
        this.timeout= setTimeout(() => callback(), wait);
      },
    }
  }
</script>

<style scoped>

</style>
